module.exports = __webpack_public_path__ + "img/icon_eye_close_.67a577b2.svg";